import { useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/context/UserAuthContext'

const Protect = ({ children }) => {
  const { user } = useAuth()

  const location = useLocation()

  const returnTo = () => {
    return (
      '?' +
      new URLSearchParams({
        return_to: `${location?.pathname}${location?.search}`,
      }).toString()
    )
  }

  if (!user) {
    window.location.href = `/login${returnTo()}`
    return null
  }
  return children
}

export default Protect
